import _toConsumableArray from "/builds/airbud/widget-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/builds/airbud/widget-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { Buffer } from "buffer";

var setupSocket = function setupSocket(_ref) {
  var serverUrl = _ref.serverUrl,
      location = _ref.location,
      connectionEvents = _ref.connectionEvents,
      config = _ref.config,
      eventHandlers = _ref.eventHandlers;
  var hasConnectedBefore = false;
  var socket = new WebSocket(serverUrl + "/widget-client?" + Object.entries(config).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        val = _ref3[1];

    return !!val;
  }) // eslint-disable-line
  .map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        val = _ref5[1];

    return "".concat(key, "=").concat(val);
  }).join("&"));
  socket.binaryType = "arraybuffer"; // Add custom "emit" method.

  socket.emit = function (type) {
    if (socket.readyState === WebSocket.OPEN) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      socket.send(JSON.stringify({
        type: type,
        args: args || []
      }));
    }
  }; // Add custom 'on' method to register an event handler.


  socket.on = function (event, handler) {
    if (handler) {
      eventHandlers[event] = handler;
    }
  };

  socket.sendBinary = function (data) {
    socket.send(data);
  };

  var dispatch = function dispatch(type) {
    if (eventHandlers[type]) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      eventHandlers[type].apply(eventHandlers, args);
    }
  };

  socket.onmessage = function (event) {
    if (event.data instanceof ArrayBuffer) {
      return eventHandlers.onAudioData(event.data);
    }

    try {
      var _JSON$parse = JSON.parse(event.data),
          type = _JSON$parse.type,
          args = _JSON$parse.args;

      dispatch.apply(void 0, [type].concat(_toConsumableArray(args)));
    } catch (e) {
      console.error("could not handle message " + e);
    }
  };

  socket.onopen = function () {
    hasConnectedBefore = true;
    socket.emit("connect", {
      location: location,
      connectionEvents: connectionEvents,
      message: "Server Connected to Client"
    });
    socket.emit("pong");
  };

  socket.onclose = function (event) {
    if (hasConnectedBefore) {
      dispatch("disconnect", event);
    }
  };

  socket.onerror = eventHandlers.onError;
  return socket;
};

export default (function (_ref6) {
  var serverUrl = _ref6.serverUrl,
      externalUserId = _ref6.externalUserId,
      botId = _ref6.botId,
      location = _ref6.location,
      connectionEvents = _ref6.connectionEvents,
      deviceInfo = _ref6.deviceInfo,
      eventHandlers = _ref6.eventHandlers;
  var socket = setupSocket({
    serverUrl: serverUrl,
    location: location,
    connectionEvents: connectionEvents,
    config: {
      externalUserId: externalUserId,
      snippetId: botId,
      paramsEncoded: Buffer.from(JSON.stringify({
        location: location,
        browserInfo: deviceInfo
      }), "utf-8").toString("base64")
    },
    eventHandlers: eventHandlers
  });
  socket.on("connected", eventHandlers.onConnected);
  socket.on("transcription", function (text, isFinal, error) {
    eventHandlers.onTranscriptionData(text, isFinal, error);
  });
  socket.on("agentMessage", function (action) {
    eventHandlers.onAgentMessage(action);
  });
  socket.on("features", function (features) {
    eventHandlers.onFeatures(features);
  });
  socket.on("ping", function () {
    socket.emit("pong");
  });
  socket.on("thinking", eventHandlers.onThinking);
  socket.on("disconnect", eventHandlers.onDisconnect);
  return {
    sendConversationStart: function sendConversationStart() {
      socket.emit("conversationStart");
    },
    sendTextUtterance: function sendTextUtterance(utterance) {
      socket.emit("textQuery", utterance);
    },
    sendUtteranceSuggestion: function sendUtteranceSuggestion(utterance) {
      socket.emit("utteranceSuggestionQuery", utterance);
    },
    sendAudioSamples: function sendAudioSamples(samples) {
      socket.sendBinary(samples);
    },
    sendRecordingStreamStart: function sendRecordingStreamStart(sampleRate, sampleSize) {
      socket.emit("startAudioStream", {
        sampleRate: sampleRate,
        sampleSize: sampleSize
      });
    },
    sendRecordingStreamEnd: function sendRecordingStreamEnd() {
      socket.emit("endAudioStream");
    },
    sendEvent: function sendEvent(type, data) {
      socket.emit("event", {
        eventType: type,
        data: data
      });
    },
    on: socket.on
  };
});